import { ColorInput, Select } from "@mantine/core";
import type { PillowVariant } from "../../api/pillows";
import { REMOVAL_MODES } from "../../types/api";

/** The pillow variant inputs (colour + removal mode), shared by the Generate page and the detail "add colour" form. */
export default function PillowVariantFields({
  value,
  onChange,
  disabled,
}: {
  value: PillowVariant;
  onChange: (value: PillowVariant) => void;
  disabled?: boolean;
}) {
  return (
    <>
      <ColorInput
        label="Background color"
        value={value.color}
        onChange={(color) => onChange({ ...value, color })}
        format="hex"
        swatches={["#ffffff", "#000000", "#f5f5f5", "#e0e0e0", "#1a1a2e", "#16213e"]}
        disabled={disabled}
      />
      <Select
        label="Removal mode"
        value={value.removalMode}
        onChange={(v) => {
          if (v === null) throw new Error("Removal mode cannot be empty");
          onChange({ ...value, removalMode: v });
        }}
        data={REMOVAL_MODES}
        allowDeselect={false}
        disabled={disabled}
      />
    </>
  );
}
